function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18n from 'invision-core/src/components/i18n/i18n';
import flatten from 'ramda/src/flatten';
import pathOr from 'ramda/src/pathOr';
import pluck from 'ramda/src/pluck';
import CustomerCareKeys from '../../../../locales/keys';
import { getTransitionOfferingMetadata, retrieveTransitionContext, setTransitionOfferingsMetadata } from '../../../../reducers/actions/transition.offer.wizard.actions';
import { TransitionContextSelector, TransitionCurrentOfferingsSelector, TransitionCurrentOffersSavingsSelector, TransitionOfferingsSelector, TransitionOffersSavingsSelector, TransitionParsedOutcomesSelector } from '../../../../reducers/selectors/transition.offer.wizard.selectors';
import { OfferingMetadataPricingPlansSelector } from 'invision-core/src/components/metadata/offerings/offerings.selectors';
import { PagesIsFetchingDataSelector } from '../../../../reducers/selectors/selected.offering.order.selectors';
import { CurrentCustomerCurrencyCodeSelector, CurrentCustomerSelector, StoreOrderSelector } from '../../../../reducers/selectors/customer.selectors';
import { PRICING_PLAN_SERVICE_RELATIONSHIP_TYPE } from '../../../../customercare.constants';
import { TransitionStates } from '../../../../reducers/constants/transition.offer.wizard.constants';
var CompareStepComponent = /*#__PURE__*/function () {
  function CompareStepComponent($ngRedux, uiNotificationService) {
    _classCallCheck(this, CompareStepComponent);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      uiNotificationService: uiNotificationService,
      CustomerCareKeys: CustomerCareKeys,
      outcomeFilter: this.outcomeFilter.bind(this),
      providesPlanRemovalWarning: '',
      toggleOutcomeFilter: this.toggleOutcomeFilter.bind(this)
    });
  }
  return _createClass(CompareStepComponent, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.isLoading = true;
      this.transitionError = false;
      this.parsedOutcomes = [];
      this.showOnlyChanges = false;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currentCustomer: CurrentCustomerSelector(store),
          currentCustomerCurrencyCode: CurrentCustomerCurrencyCodeSelector(store),
          currentOfferings: TransitionCurrentOfferingsSelector(store),
          currentOfferingSavings: TransitionCurrentOffersSavingsSelector(store),
          isFetchingData: PagesIsFetchingDataSelector(store),
          offeringMetadataPricingPlans: OfferingMetadataPricingPlansSelector(store),
          outcomes: TransitionParsedOutcomesSelector(store),
          storeOrder: StoreOrderSelector(store),
          transitionContext: TransitionContextSelector(store),
          transitionOfferings: TransitionOfferingsSelector(store),
          transitionOfferingSavings: TransitionOffersSavingsSelector(store)
        };
      };
      var controllerActions = {
        getTransitionOfferingMetadata: getTransitionOfferingMetadata,
        retrieveTransitionContext: retrieveTransitionContext,
        setTransitionOfferingsMetadata: setTransitionOfferingsMetadata
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.currencyCode = this.state.currentCustomerCurrencyCode;
      var offeringId = pathOr(null, ['Context', 'OfferingIds', '0'], this.state.storeOrder);
      this.actions.retrieveTransitionContext(this.customerId, this.selectedOfferId ? this.selectedOfferId : offeringId, this.fromOfferId, this.offeringInstanceId).then(function (response) {
        _this.transitionError = false;
        _this.isLoading = false;
        var offeringsIds = Array.from(new Set(pluck('Id', response.TransitionContext.CurrentOfferings).concat(pluck('Id', response.TransitionContext.TransitionOfferings))));
        _this.setChangeProvidesPlanWarning();
        Promise.all(offeringsIds.map(function (id) {
          return _this.actions.getTransitionOfferingMetadata(id, _this.state.currentCustomer.Language);
        })).then(function (response) {
          _this.actions.setTransitionOfferingsMetadata(response);
        }).catch(function (error) {
          _this.uiNotificationService.transientError(error.translatedMessage);
        });
      }, function () {
        _this.uiNotificationService.transientError(i18n.translate(_this.CustomerCareKeys.CHANGE_OFFER.CHANGE_CONTEXT_FAILURE));
        _this.transitionError = true;
        _this.isLoading = false;
      });
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "outcomeFilter",
    value: function outcomeFilter(item) {
      return !this.showOnlyChanges || item.isRemoval || item.isChange || item.isAddition;
    }
  }, {
    key: "toggleOutcomeFilter",
    value: function toggleOutcomeFilter() {
      this.showOnlyChanges = !this.showOnlyChanges;
    }
  }, {
    key: "getExistingOfferTitle",
    value: function getExistingOfferTitle() {
      return this.state.currentOfferings.length === 1 ? i18n.translate(this.CustomerCareKeys.CHANGE_OFFER.EXISTING_OFFER, {
        offeringName: this.state.currentOfferings[0].DisplayName || this.state.currentOfferings[0].Name
      }) : i18n.translate(this.CustomerCareKeys.CHANGE_OFFER.EXISTING_OFFERS);
    }
  }, {
    key: "getTransitionOfferTitle",
    value: function getTransitionOfferTitle() {
      return i18n.translate(this.CustomerCareKeys.CHANGE_OFFER.NEW_OFFER, {
        offeringName: this.state.transitionOfferings[0].DisplayName || this.state.transitionOfferings[0].Name
      });
    }
  }, {
    key: "setChangeProvidesPlanWarning",
    value: function setChangeProvidesPlanWarning() {
      var _this2 = this;
      var offeringPlans = flatten(this.state.currentOfferings.map(function (item) {
        return item.Items;
      }));
      var removedPlans = offeringPlans.filter(function (plan) {
        return plan.TransitionState === TransitionStates.REMOVED && _this2.state.offeringMetadataPricingPlans[plan.PricingPlanId].ServiceRelationshipType === PRICING_PLAN_SERVICE_RELATIONSHIP_TYPE.PROVIDES;
      });
      if (removedPlans.length) {
        this.providesPlanRemovalWarning = removedPlans.length > 1 ? i18n.translate(CustomerCareKeys.DECISIONS.REMOVE_PLAN_ASSOCIATIONS_GENERIC) : i18n.translate(CustomerCareKeys.DECISIONS.REMOVE_PLAN_ASSOCIATIONS_SINGLE, {
          pricingPlanName: this.state.offeringMetadataPricingPlans[removedPlans[0].PricingPlanId].PricingPlanName
        });
      }
    }
  }]);
}();
export default {
  template: require('./compare.html'),
  bindings: {
    customerId: '<',
    selectedOfferId: '<',
    fromOfferId: '<',
    offeringInstanceId: '<'
  },
  controller: CompareStepComponent,
  controllerAs: 'CompareStepController'
};